import { SubMenu, MenuItem, Menu } from "@szhsin/react-menu"
import { HelperConfig } from "./Helpers"
import { HelperState } from "./HelperState"
import { useGetAllHelpers, useHelperStore } from "./HelperStore"
import { BsWindow } from "react-icons/bs"
import './HelperMenu.scss'

export function HelperMenu(){
    const allHelpers:HelperConfig[] = useGetAllHelpers()
    const openHelper:Function =  useHelperStore((state:HelperState)=>state.openHelper)
    const closeHelper:Function =  useHelperStore((state:HelperState)=>state.closeHelperByIndex)
    const openAllHelpers = useHelperStore((state:HelperState)=>state.openAllHelpers)
    const closeAllHelpers = useHelperStore((state:HelperState)=>state.closeAllHelpers)
    const toggleHelper = (e:any) => {
        const index:number = e.value
        const helper:HelperConfig = allHelpers[index]
        if(helper.displayOrder === 0){
            openHelper(index)
            return
        }
        closeHelper(index)
    }
    const getMainButton = () =>{
        return (<button className={'helper-button'}>
            <div className={'label'}>Helper Patterns</div>
            <div className={'icon'}>
                <BsWindow />
            </div>
        </button>)
 
    }
    return(
        <Menu menuButton={getMainButton()}>
            {allHelpers.map((helper:HelperConfig, index:number)=>{
                return(<MenuItem
                    type="checkbox"
                    checked={(helper.displayOrder !== 0)}
                    onClick={toggleHelper}
                    value={index}
                    key={index}
                >{helper.title}</MenuItem> 
                )
            })}
            <MenuItem onClick={openAllHelpers}>Open All</MenuItem>
            <MenuItem onClick={closeAllHelpers}>Close All</MenuItem>
        </Menu>
    )
}